<div class="d-flex fd-col ai-stretch">
  <h4 class="margin" *ngIf="heading">{{ heading }}</h4>
  <p *ngIf="intro">{{intro}}</p>
  <div class="card margin ">
    <suvo-bi-route-selector [links]="selectLinks" [showIcons]="true">
    </suvo-bi-route-selector>
  </div>
</div>